<template>
  <div class="login_container">
    <!-- <el-dropdown>
      <span class="el-dropdown-link">
        {{$t('loginPage.language')}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="changeLang('zh')" :disabled="$i18n.locale == 'zh'">中文</el-dropdown-item>
        <el-dropdown-item @click.native="changeLang('en')" :disabled="$i18n.locale == 'en'">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    <el-card class="login-form-layout">
      <el-form autocomplete="on"
               :model="loginForm"
               :rules="rules"
               ref="loginForm"
               v-loading="loading"
               label-position="left"
               style="text-align: center">
        <h2 class="login-title color-main">{{ $t("loginPage.title") }}</h2>
        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input name="username"
                    type="text"
                    v-model="loginForm.username"
                    autocomplete="on"
                    clearable
                    @input="changeChinese"
                    :placeholder="$t('loginPage.usernamePlaceholder')">
            <img class="img"
                 slot="prepend"
                 src="../assets/userName.svg">
            <!-- <i class="el-icon-user" slot="prepend"></i> -->
          </el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input name="password"
                    show-password
                    clearable
                    v-model="loginForm.password"
                    autocomplete="on"
                    :placeholder="$t('loginPage.passwordPlaceholder')">
            <img class="img"
                 slot="prepend"
                 src="../assets/password.svg">
            <!-- <i class="el-icon-lock" slot="prepend"></i> -->
          </el-input>
        </el-form-item>
        <!-- 输入验证码 -->
        <el-form-item prop="verifycode">
          <!-- 注意：prop与input绑定的值一定要一致，否则验证规则中的value会报undefined，因为value即为绑定的input输入值 -->
          <el-input v-model="loginForm.verifycode"
                    :placeholder="$t('loginPage.verifyCodePlaceholder')"
                    maxlength="4"
                    clearable
                    @keyup.enter.native="handleLogin"
                    @input="changeChinese"
                    class="identifyinput">
            <!-- <i class="el-icon-edit-outline" slot="prepend"></i> -->
            <img class="img"
                 slot="prepend"
                 src="../assets/verifycode.svg">
            <!-- <el-button
              @click="getCode"
              :disabled="isdisabled"
              slot="append"
              type="text"
              size="small"
              class="textbtn"
              style="padding: 0 5px 0 5px; font-size: 10px"
              >&nbsp;{{ $t("loginPage.changeVerityCode") }}&nbsp;</el-button
            > -->
          </el-input>
          <!-- 验证码 -->
          <el-button :disabled="isdisabled"
                     @click="getCode"
                     style="float:right;width:180px;height:40px;padding:0;border:0;"
                     v-loading="loadingCode">
            <el-image :src="kaptcha">
              <div slot="error"
                   class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-button>
        </el-form-item>
        <!-- 选择语言 -->
        <el-form-item prop="language">
          <el-input class="combineInput">
            <img class="img"
                 slot="prepend"
                 src="../assets/language.svg" />
            <el-select class="selectLanguage"
                       v-model="loginForm.language"
                       placeholder="请选择"
                       @change="changeLang"
                       slot="append">
              <el-option v-for="item in languageOption"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <!-- 验证码 -->
        <!-- <el-form-item style="text-align: center">
          <div class="identifybox">
            <el-image :src="kaptcha">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-form-item> -->
        <el-form-item style="margin-bottom: 60px">
          <el-button style="width: 100%"
                     type="primary"
                     @click.native.prevent="handleLogin">{{ $t("loginPage.loginBtn")
          }}</el-button>
        </el-form-item>
        <!-- <el-form-item style="margin-bottom: 10px"
                      size="small"> -->
        <!-- <span>
          <el-link type="primary"
                   href="/register">{{$t('loginPage.registerLink')}}</el-link>
          <el-link type="primary"
                   style="margin-left:80px;"
                   href="/forget">{{$t('loginPage.forgetPasswordLink')}}</el-link>
        </span> -->
        <!-- </el-form-item> -->
      </el-form>
    </el-card>
    <!-- 备案号 -->
    <div style="position: fixed; width: 100%; bottom: 0px">
      <p style="line-height: 22px; font-size: 10px; text-align: center">
        <a href="https://beian.miit.gov.cn/"
           target="_blank"
           style="cursor: pointer; color: rgb(223 221 221); text-decoration: none">苏ICP备13035339号-5</a>
      </p>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Cookies from "js-cookie";
export default {
  name: "login",
  data () {
    // 初始化校验规则
    var validateUserNameBlank = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("loginPage.userNameCheck")));
      }
      callback();
    };
    var validatePasswordBlank = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("loginPage.passwordCheck")));
      }
      callback();
    };
    var validateVerifycodeBlank = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("loginPage.verifyCodeCheck")));
      }
      callback();
    };
    return {
      // 校验规则
      rules: {
        // 主要通过validator来指定验证器名称
        username: [
          {
            required: true,
            validator: validateUserNameBlank,
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            validator: validatePasswordBlank,
            trigger: ["blur", "change"],
          },
        ],
        verifycode: [
          {
            required: true,
            validator: validateVerifycodeBlank,
            trigger: ["blur", "change"],
          },
        ],
      },
      loginForm: {
        username: "",
        password: "",
        verifycode: "",
        language: this.$i18n.locale,
      },
      kaptcha: "",
      loading: false,
      loadingCode: false,
      isdisabled: false,
      countdown: 2,
      timer: null,
      languageOption: [
        {
          value: "zh",
          label: "简体中文",
        },
        // {
        //   value: "en",
        //   label: "English",
        // },
      ],
    };
  },
  components: {},
  created () { },
  mounted () {
    // 获取验证码
    this.getCode();
  },
  computed: {},
  props: [],
  methods: {
    // 正则：禁止中文录入
    changeChinese () {
      this.$nextTick(() => {
        if (this.loginForm.verifycode) {
          this.loginForm.verifycode = this.loginForm.verifycode
            .replace(/[\u4E00-\u9FA5]/g, "")
            .replace(" ", "");
        }
        if (this.loginForm.username) {
          this.loginForm.username = this.loginForm.username
            .replace(/[\u4E00-\u9FA5]/g, "")
            .replace(" ", "");
        }
      });
    },
    // 登录
    handleLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 校验验证码
          let url = "/api/login/verifyCode";
          // 访问对应的后端的api获取登录信息
          this.$http
            .post(url, qs.stringify({ verifyCode: this.loginForm.verifycode }))
            .then((response) => {
              if (response.data.code === 200) {
                // 验证码没问题，开始登录
                let url = "/api/login/loginOn";
                // 访问对应的后端的api获取登录信息
                this.$http
                  .post(
                    url,
                    qs.stringify({
                      username: this.loginForm.username,
                      password: this.loginForm.password,
                    })
                  )
                  .then((response) => {
                    this.loading = false;
                    this.response = JSON.stringify(response.data);
                    if (response.data.code === 200) {
                      localStorage.user = this.loginForm.username;
                      localStorage.userId = response.data.data.user_id;
                      Cookies.set("access_token", response.data.data.access_token, {
                        expires: 1,
                      });
                      this.$message(
                        this.$t("loginPage.welcomeMessage") +
                        this.loginForm.username +
                        "！"
                      );
                      // 如果是首次登陆则跳转到修改密码画面，并提示用户修改密码
                      if (response.data.data.login_first === '0') {
                        sessionStorage.loginFirst = '0'
                        const that = this;
                        setTimeout(() => {
                          // 跳转到修改密码的页面
                          that.$router.push("views/Mine/P0901");
                        });
                        return
                      }
                      // 登录成功则跳转到原路径，否则跳回主页
                      const that = this;
                      setTimeout(() => {
                        // 要求重新加载导航菜单
                        this.$store.commit("menuRouteLoaded", false);
                        this.$store.commit("setNavTree", []);
                        // 设置主页路径
                        let path = "/";
                        if (that.$route.query.redirect) {
                          path = that.$route.query.redirect;
                        }
                        // 242、243 用户登录跳转
                        if (response.data.data.user_id === '242'||response.data.data.user_id === '243'){
                          // 跳转资源用户管理 需求管理
                          return that.$router.push('/views/ResourceBaseManagement/DemandMgt/Index');
                        }
                        that.$router.push(path);
                      });
                    } else {
                      // this.$message.error('用户名或密码不正确！')
                      this.$message.error(response.data.message);
                      this.getCode();
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    console.log(err);
                    this.$message.error(this.$t("loginPage.loginFailed"));
                    this.getCode();
                  });
              } else {
                this.loading = false;
                this.$message.error(response.data.message);
                this.getCode();
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              this.$message.error(this.$t("loginPage.verificationFailed"));
              this.getCode();
            });
        }
      });
      /* } */
    },
    /**
     * 获取验证码
     */
    getCode () {
      let url = "/api/login/getCode";
      this.loadingCode = true
      this.isdisabled = true;
      this.$http
        .get(url)
        .then((response) => {
          this.loadingCode = false
          if (response.data.code === 200) {
            if (response.data.name === "mockKaptch") {
              this.kaptcha = response.data.imgUrl;
            } else {
              this.kaptcha = "data:image/png;base64," + response.data.data;
            }
          } else {
            this.$message.error(this.$t("loginPage.connectionError"));
          }
          this.setTimer();
        })
        .catch((err) => {
          this.loadingCode = true
          console.log(err);
          this.$message.error(this.$t("loginPage.connectionError"));
          this.setTimer();
        });
    },
    setTimer () {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 2) {
            this.isDisabled = true;
            this.countdown--;
            if (this.countdown !== 0) {
            } else {
              clearInterval(this.timer);
              this.countdown = 2;
              this.timer = null;
              this.isdisabled = false;
            }
          }
        }, 1000);
      }
    },
    // 切换语言
    changeLang (lang) {
      // 更新localStorage中的值
      localStorage.setItem("locale", lang);
      // 修改i18n的语言标志
      this.$i18n.locale = localStorage.getItem("locale");
      location.reload();

      // 通知后台，语言修改了
      // this.$http.get('/api/login/changeLang?lang=' + lang).then(res => {
      //     if (res.data.code === 500) {
      //       this.$message.error(res.data.data)
      //     } else if (res.data.code === 200) {
      //       this.$message({
      //         // '切换为中文！'   'Switch to English!'
      //         message: res.data.data,
      //         type: 'success'
      //       })
      //     }
      //   }).catch(e => {
      //     console.log(e)
      //   })
    },
  },
};
</script>
<style lang="sss" scoped>
.login_container {
  position: absolute;
  width: 100%;
  height: 100%;
  /* min-width: 1024px ;
  min-height: 768px ; */
  background-image: url("../assets/bg.jpg");
  /* background-size: cover; */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  background-position: top center;

  min-width: 401px;
}
/* @import "../assets/style.css"; */
.base-background {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #409eff;
}
.login-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  width: 400px;
  margin: 13% auto;
  border-top: 10px solid #409eff;
}

.login-title {
  text-align: center;
}

.login-center-layout {
  background: #409eff;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  margin-top: 200px;
}
.lizi {
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
}
.identifyinput {
  width: 170px;
  float: left;
}
.combineInput >>> .el-input__inner {
  width: 0px;
  padding: 0;
  border-right: none;
}
.selectLanguage >>> .el-input__inner {
  width: 305px;
  padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue